export const TextWithWhitespaces = (props: { text: string }) => (
  <span style={{ whiteSpace: "pre" }}>{props.text}</span>
);
